export const THEME_CONFIG = {
	locale: localStorage.getItem('locale') || 'es',
};